<template>
<div class="container">
    <div class="row">
        <div class="col-sm-6 text-left  small">
            <h5>Hanse-Domizil Gesellschaft mit beschränkter Haftung</h5>
            Vertretungsberechtige Geschäftsführerin: Kerstin Sperling<br><br>
            Mecklenburgstraße 34<br>
            D-19053 Schwerin<br>
            Telefon: 0385 / 59 23 186<br>
            Fax: 0385 / 59 23 188<br>
            EMail: info@hanse-domizil.de<br>
        </div>
        <div class="col-sm-6 text-left small">
            Registergericht: Amtsgericht Schwerin<br>
            Registernummer: beantragt<br>
            <br>
            Umsatzsteuer-Identifikationsnummer gem. § 27a UStG: DE 2229103189<br><br>
            <div class="row">
                <div class="col-sm-8 small">Inhaltlich Verantwortlicher gem. § 55 II RStV:</div>
                <div class="col-sm-4">Enrico Schulz</div>
                <div class="col-sm-8"></div>
                <div class="col-sm-4">Wismarsche Strasse 258<br>19053 Schwerin</div>
            </div>
        </div>
    </div>
<!--    <div class="row">
        <div class="col-md-12" style="height: 400px">
                <l-map :zoom="zoom" :center="center">
                    <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
                    <l-marker :lat-lng="marker"></l-marker>
                </l-map>
        </div>
    </div>-->
</div>
</template>

<script>
// import Vue from 'vue'
// import { 
//     L, 
//     Icon 
// } from 'leaflet'
// import 'leaflet/dist/leaflet.css'
// import { LMap, LTileLayer, LMarker } from 'vue2-leaflet'
// Vue.component('l-map', LMap);
// Vue.component('l-tile-layer', LTileLayer);
// Vue.component('l-marker', LMarker);
// delete Icon.Default.prototype._getIconUrl;

// Icon.Default.mergeOptions({
//     iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
//     iconUrl: require('leaflet/dist/images/marker-icon.png'),
//     shadowUrl: require('leaflet/dist/images/marker-shadow.png')
// });

export default {
    // components: {
    //     LMap,
    //     LTileLayer,
    //     LMarker
    // },
    mounted() {
        this.$ga.screenview('impressum')
    },
    data() {
        return {
            zoom: 16,
            // center: L.latLng(54.801320, 9.478610),
            url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
            //attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            // marker: L.latLng(54.801320, 9.478610),
        }
    },
    methods: {
        geolocate: function () {
            // navigator.geolocation.getCurrentPosition(position => {
            //     this.center = {
            //         lat: position.coords.latitude,
            //         lng: position.coords.longitude
            //     };
            // });
        }
    }

}
</script>

<style>

</style>
